import { Column } from "../objects/column";


export const NOT_ONLINE_AGENCY_COLUMN: Column[] = [{
	label: 'name',
	field_name: 'NAME',
	checked: true,
	order_by: 'name',
	fixed_width: false,
	last_updated: false,
	width: null
}, {
	label: 'destination',
	field_name: 'DESTINATION',
	checked: true,
	order_by: 'current_version__destination__current_version__localization__name',
	fixed_width: false,
	last_updated: false
},
{
	label:'itinerary-type-with-products',
	field_name: 'ITINERARY_TYPE_WITH_PRODUCTS',
	checked: true,
	order_by: 'itinerary_type_with_products',
	fixed_width: true,
	last_updated: false
},
{
	label: 'online',
	field_name: 'VISIBILITY',
	checked: true,
	order_by: '',
	fixed_width: true,
	last_updated: false,
	width: null
}, {
	label: 'categories',
	field_name: 'CATEGORIES',
	checked: true,
	order_by: '',
	fixed_width: false,
	last_updated: false,
	width: null
}, {
	label: 'created-date',
	field_name: 'CREATED_DATE',
	checked: false,
	order_by: 'created_date',
	fixed_width: true,
	last_updated: false,
	width: null
}, {
	label: 'created-by',
	field_name: 'CREATED_BY',
	checked: false,
	order_by: 'creator__username',
	fixed_width: true,
	last_updated: false,
	width: null
}, {
	label: 'modified-date',
	field_name: 'MODIFIED_DATE',
	checked: true,
	order_by: 'modified_date',
	fixed_width: true,
	last_updated: false,
	width: null
}, {
	label: 'modified-by',
	field_name: 'MODIFIED_BY',
	checked: true,
	order_by: 'last_author__username',
	fixed_width: true,
	last_updated: false,
	width: null
}];

export const DEFAULT_COLUMN: Column[] = [{
	label: 'name',
	field_name: 'NAME',
	checked: true,
	order_by: 'name',
	fixed_width: false,
	last_updated: false,
	width: null
}, {
	label: 'destination',
	field_name: 'DESTINATION',
	checked: true,
	order_by: 'current_version__destination__current_version__localization__name',
	fixed_width: false,
	last_updated: false
},
{
	label:'itinerary-type-with-products',
	field_name: 'ITINERARY_TYPE_WITH_PRODUCTS',
	checked: true,
	order_by: 'itinerary_type_with_products',
	fixed_width: true,
	last_updated: false
},
{
	label: 'online-to',
	field_name: 'VISIBILITY',
	checked: true,
	order_by: '',
	fixed_width: true,
	last_updated: false
},
{
	label: 'online-b2b',
	field_name: 'AGENCY_VISIBILITY',
	checked: true,
	order_by: '',
	fixed_width: true,
	last_updated: false,
	width: null
}, {
	label: 'categories',
	field_name: 'CATEGORIES',
	checked: true,
	order_by: '',
	fixed_width: false,
	last_updated: false,
	width: null
}, {
	label: 'created-date',
	field_name: 'CREATED_DATE',
	checked: false,
	order_by: 'created_date',
	fixed_width: true,
	last_updated: false,
	width: null
}, {
	label: 'created-by',
	field_name: 'CREATED_BY',
	checked: false,
	order_by: 'creator__username',
	fixed_width: true,
	last_updated: false,
	width: null
}, {
	label: 'modified-date',
	field_name: 'MODIFIED_DATE',
	checked: true,
	order_by: 'modified_date',
	fixed_width: true,
	last_updated: false,
	width: null
}, {
	label: 'modified-by',
	field_name: 'MODIFIED_BY',
	checked: true,
	order_by: 'last_author__username',
	fixed_width: true,
	last_updated: false,
	width: null
}];